import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const PaymentDetailPage = lazy(() => import('./Detail.page'));

export const PaymentDetail = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <PaymentDetailPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
